import React, { useMemo } from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { SUBSCRIPTION_GENERAL_DETAILS } from '@shared/data/mockSubscriptions';
import type { Subscription } from '@/features/subscriptions/types/subscriptions/subscription.types';
import type { PaymentDetail } from '@shared/components/panels/types/panel-common.types';

interface GeneralSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  subscriptionData?: Subscription;
  className?: string;
}

function buildGeneralDetails(subscription: Subscription): PaymentDetail[] {
  return [
    { label: 'Customer', value: subscription.customer },
    { label: 'Plan', value: subscription.plan },
    { label: 'Created', value: subscription.created },
    { label: 'Current period', value: '-' },
    { label: 'Trial', value: '-' },
    { label: 'PO Number', value: '-' },
    { label: 'Invoice memo', value: '-' },
  ];
}

export const GeneralSection = React.memo<GeneralSectionProps>(({ isExpanded, onToggle, isDetailView = false, subscriptionData, className }) => {
  const details = useMemo(
    () => subscriptionData ? buildGeneralDetails(subscriptionData) : SUBSCRIPTION_GENERAL_DETAILS,
    [subscriptionData]
  );

  return (
    <CollapsibleDetailsSection
      title="General"
      details={details}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No general details available"
      className={className}
    />
  );
});

GeneralSection.displayName = 'GeneralSection';
